import { render, staticRenderFns } from "./goodCategoryList.vue?vue&type=template&id=ecd2d8d0&scoped=true"
import script from "./goodCategoryList.vue?vue&type=script&lang=js"
export * from "./goodCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd2d8d0",
  null
  
)

export default component.exports